import { makeAutoObservable } from 'mobx';
import { IAdminUsersStore } from './IAdminUsersStore';
import { AdminUserMetricsDTO, AdminUserListItemDTO } from 'infrastructure/dtos/admin';
import { IAdminUserService } from 'application/services/admin';

const DEFAULT_PER_PAGE = 15;

export class AdminUsersStore implements IAdminUsersStore {
  private _metrics: AdminUserMetricsDTO | undefined = undefined;
  private _data: AdminUserListItemDTO[] = [];
  private _currentPage: number = 1;
  private _perPage: number = DEFAULT_PER_PAGE;
  private _total: number = 0;
  private _lastPage: number = 0;
  private _isLoading: boolean = false;
  private _search: string = '';

  constructor(private readonly service: IAdminUserService) {
    makeAutoObservable(this);
  }

  get metrics(): AdminUserMetricsDTO | undefined {
    return this._metrics;
  }

  get users(): AdminUserListItemDTO[] {
    return this._data;
  }

  get currentPage(): number {
    return this._currentPage;
  }

  get perPage(): number {
    return this._perPage;
  }

  get total(): number {
    return this._total;
  }

  get lastPage(): number {
    return this._lastPage;
  }

  get isLoading(): boolean {
    return this._isLoading;
  }

  setSearch(search: string): void {
    this._search = search;
  }

  async fetchUsers(params?: {
    page?: number;
    search?: string;
    role?: 'creative';
    per_page?: number;
  }): Promise<void> {
    this._isLoading = true;
    try {
      const page = params?.page ?? this._currentPage;
      const search = params?.search !== undefined ? params.search : this._search;
      const per_page = params?.per_page ?? this._perPage;

      const response = await this.service.getUsers({
        page,
        ...(search && { search }),
        role: 'creative',
        per_page,
      });

      this._metrics = response.metrics;
      this._data = response.data;
      this._currentPage = response.current_page;
      this._perPage = response.per_page;
      this._total = response.total;
      this._lastPage = response.last_page;
    } finally {
      this._isLoading = false;
    }
  }
}
